module.exports = __webpack_public_path__ + "img/stage_spitzwegerich.f04eeb33.jpg";